var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdultsIcon = function SvgAdultsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98.267,
    height: 52.224,
    viewBox: "0 0 98.267 52.224",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1629",
    "data-name": "Ret\\xE2ngulo 1629",
    width: 51.728,
    height: 52.224,
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1630",
    "data-name": "Ret\\xE2ngulo 1630",
    width: 39.177,
    height: 47.408,
    fill: "#4b4b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5864",
    "data-name": "Grupo 5864",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5851",
    "data-name": "Grupo 5851",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4453",
    "data-name": "Caminho 4453",
    d: "M27.83,44.513c.021-1.127-.365-1.816-1.1-2.025a2.3,2.3,0,0,0-1.155,0c-.735.208-1.122.9-1.1,2.025-.027,1.4.562,2.131,1.679,2.1,1.115.035,1.7-.7,1.677-2.1",
    transform: "translate(-6.456 -11.189)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4454",
    "data-name": "Caminho 4454",
    d: "M44.962,42.488a2.3,2.3,0,0,0-1.155,0c-.735.208-1.123.9-1.1,2.025-.028,1.4.562,2.131,1.677,2.1,1.116.035,1.706-.7,1.678-2.1.022-1.127-.364-1.816-1.1-2.025",
    transform: "translate(-11.266 -11.189)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4455",
    "data-name": "Caminho 4455",
    d: "M33.919,55.2l.222.112a2.785,2.785,0,0,0,2.223,0l.223-.112c.4-.2.483-.381.281-.479a1.319,1.319,0,0,0-.541-.083H34.18a1.309,1.309,0,0,0-.541.083c-.2.1-.122.276.28.479",
    transform: "translate(-8.846 -14.412)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4456",
    "data-name": "Caminho 4456",
    d: "M38.494,57.62c-.053.065-1.333,1.6-4.638,1.6s-4.58-1.528-4.638-1.6a.551.551,0,0,0-.865.683c.064.082,1.625,2.019,5.5,2.019s5.439-1.938,5.5-2.019a.551.551,0,0,0-.866-.683",
    transform: "translate(-7.448 -15.145)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4457",
    "data-name": "Caminho 4457",
    d: "M28.9,37.611a.459.459,0,0,0-.46-.459H23.85a.459.459,0,0,0,0,.919h4.594a.459.459,0,0,0,.46-.459",
    transform: "translate(-6.171 -9.8)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4458",
    "data-name": "Caminho 4458",
    d: "M45.916,37.152H41.322a.459.459,0,1,0,0,.919h4.594a.459.459,0,0,0,0-.919",
    transform: "translate(-10.779 -9.8)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4459",
    "data-name": "Caminho 4459",
    d: "M51.724,28.615a3.581,3.581,0,0,0-2.3-3.56,5.435,5.435,0,0,0,.919-4.134c-.387-2.8-3.791-3.791-3.791-3.791a5.9,5.9,0,0,0,.23-5.742c-1.573-3.1-5.513-2.871-5.513-2.871s.92-2.641-2.067-4.363c-2.838-1.637-5.972.229-5.972.229S32.7.324,27.645.018c-4.836-.293-6.2,3.063-6.2,3.063A6.062,6.062,0,0,0,16.287,2.8c-3,1.113-3.037,4.488-3.037,4.488s-3.365-1.651-4.938.88-.918,4.249-.918,4.249-2.871.46-3.675,2.871c-.888,2.664.23,4.02.23,4.02a6.127,6.127,0,0,0-2.641,4.135,6.2,6.2,0,0,0,.964,4.19A6.381,6.381,0,0,0,.044,31.6C-.371,34.24,2.34,36.2,2.34,36.2s-1.314,1.485.345,3.789a3.121,3.121,0,0,0,4.595.919s.344,3.79,3.216,3.9a2.584,2.584,0,0,0,2.475-1.443,17.3,17.3,0,0,0,2.583,3.967,14.493,14.493,0,0,0,21.711,0,17.907,17.907,0,0,0,3.109-5.159,2.348,2.348,0,0,0,2.279,1.486c2.642,0,4.02-2.756,4.02-2.756s3.79.8,4.363-2.756c.565-3.5-1.263-5.054-1.263-5.054a5.671,5.671,0,0,0,1.952-4.479M38.4,41.222c-2.5,6.342-7.406,8.8-11.994,8.8s-9.49-2.449-11.989-8.8c-.118-.3-.229-.6-.336-.919-.1-.3-.2-.6-.287-.919a28.521,28.521,0,0,1-1.025-6.8c-.025-.336-.042-.663-.059-.991l.035-.29.081-.655a2.389,2.389,0,0,0,.774-.264,2.988,2.988,0,0,0,1.045-.919,3.679,3.679,0,0,0,.433-.791,6.766,6.766,0,0,0,.39-3.5,2.7,2.7,0,0,0,2.718-1.34,3.13,3.13,0,0,0,.345-2.449s2.909,0,3.6-2.527c0,0,.09,1.45,2.641,1.991,2.527.536,3.35-1.072,3.35-1.072A5.309,5.309,0,0,0,30.21,22.91a6.386,6.386,0,0,0,3.713.842s.63,3.322,2.029,4.1,1.684-.077,1.684-.077a11.035,11.035,0,0,0,.026,1.688c.027.293.067.6.127.919a6.948,6.948,0,0,0,.235.919c.035.1.071.2.111.3a5.7,5.7,0,0,0,1.842,2.206,27.248,27.248,0,0,1-.953,5.577c-.091.314-.186.621-.287.919q-.158.473-.334.919",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5853",
    "data-name": "Grupo 5853",
    transform: "translate(59.09 2.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4466",
    "data-name": "Caminho 4466",
    d: "M36.35,21.89a22.268,22.268,0,0,0-1.177-11.17C31.741,2.573,25.8,0,19.676,0S7.609,2.573,4.18,10.72A22.257,22.257,0,0,0,3,21.873,3.008,3.008,0,0,0,.872,22.965c-.886,1.079-1.1,2.812-.632,5.145.908,4.54,3.086,5.41,4.266,5.533C6.449,41.192,10.566,44.4,14.82,45.524a43.064,43.064,0,0,0,4.768,1.885,43.21,43.21,0,0,0,4.768-1.885c4.259-1.125,8.379-4.333,10.319-11.882,1.18-.125,3.354-1,4.26-5.532.467-2.334.256-4.066-.63-5.145A2.993,2.993,0,0,0,36.35,21.89m-1.228,9.7a43.063,43.063,0,0,0,.668-6.329c0-.027,0-.053,0-.08.1-.473.2-.967.288-1.477a1.177,1.177,0,0,1,.8.422c.506.616.593,1.9.252,3.621-.5,2.5-1.356,3.467-2.014,3.842M32.4,33.628a15.514,15.514,0,0,1-3.869,7.1,13.671,13.671,0,0,0-.732-5.87,2.7,2.7,0,0,0-1.672-1.227,4.019,4.019,0,0,0-1.453-.183.988.988,0,0,0-.456.183,1.5,1.5,0,0,0-.4.421,4.757,4.757,0,0,1,2.206,1.544c.613,1.009.367,4.229-.062,5.707s-6.37,1.812-6.37,1.812-5.942-.335-6.37-1.812-.674-4.7-.062-5.707a4.756,4.756,0,0,1,2.2-1.544,1.477,1.477,0,0,0-.4-.421.984.984,0,0,0-.457-.183,4.009,4.009,0,0,0-1.45.183,2.7,2.7,0,0,0-1.673,1.227,13.638,13.638,0,0,0-.733,5.856,15.553,15.553,0,0,1-3.864-7.083c-.085-.3-.164-.607-.239-.919S6.4,32.1,6.34,31.79a40.33,40.33,0,0,1-.755-6.683c-.009-.121-.013-.236-.02-.355l1.084.063s.081,2.928,1.168,4.241,6.218,1.292,7.758.8a3.553,3.553,0,0,0,2.513-3.372h3A3.551,3.551,0,0,0,23.6,29.852c1.54.5,6.669.516,7.756-.8s1.169-4.241,1.169-4.241l1.084-.063c-.008.133-.013.26-.023.392a40.349,40.349,0,0,1-.747,6.646c-.065.312-.133.618-.206.92s-.155.619-.239.919M2.042,27.751c-.344-1.719-.255-3.005.251-3.621a1.22,1.22,0,0,1,.952-.431h.024c.014.083.029.167.043.25.021.421.04.843.072,1.274a43.068,43.068,0,0,0,.676,6.37c-.659-.373-1.517-1.343-2.017-3.844m28.612-3.888c.451.942.463,3.512-.442,4.453s-5.625,1.014-6.593.362a3.693,3.693,0,0,1-1.081-3.947c.157-.44.906-.787,1.89-1.027,2.065-.505,5.166-.542,6.043,0a.616.616,0,0,1,.183.158m-14.017.869a3.691,3.691,0,0,1-1.081,3.947c-.969.652-5.688.578-6.593-.362s-.894-3.512-.442-4.453A.608.608,0,0,1,8.7,23.7c.878-.542,3.981-.505,6.045,0,.984.24,1.733.587,1.89,1.027m-.713-1.946a19.461,19.461,0,0,0-5.832-.66,19.692,19.692,0,0,0-4.617.628c-.007-.3-.016-.595-.018-.887q-.01-1.693.11-3.247a29.793,29.793,0,0,1,.632-3.8c1.409-5.7,4.239-7.289,7.02-7.841s4.251,2.573,6.456,2.573,3.674-3.124,6.456-2.573c2.584.512,5.209,1.928,6.7,6.7a32.56,32.56,0,0,1,.889,8.189c0,.292-.01.59-.017.887a19.7,19.7,0,0,0-4.616-.628,19.461,19.461,0,0,0-5.832.66,3.941,3.941,0,0,0-1.566.919,1.946,1.946,0,0,0-.539,1.064H18.029a1.945,1.945,0,0,0-.538-1.064,3.951,3.951,0,0,0-1.566-.919",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4467",
    "data-name": "Caminho 4467",
    d: "M16.891,36.609c1.116.029,1.7-.62,1.678-1.849.026-1.228-.562-1.879-1.678-1.847-1.116-.032-1.705.618-1.678,1.847-.027,1.229.562,1.879,1.678,1.849",
    transform: "translate(-4.013 -8.682)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4468",
    "data-name": "Caminho 4468",
    d: "M35.123,32.912c-1.118-.031-1.707.618-1.679,1.848-.027,1.229.562,1.878,1.679,1.849,1.115.029,1.7-.62,1.678-1.849.026-1.228-.563-1.879-1.678-1.848",
    transform: "translate(-8.822 -8.682)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4469",
    "data-name": "Caminho 4469",
    d: "M24.655,45.207l.222.112a1.9,1.9,0,0,0,.208.087,2.905,2.905,0,0,0,1.807,0,1.664,1.664,0,0,0,.207-.087l.223-.112c.613-.308.495-.561-.26-.561H24.916c-.756,0-.872.253-.261.561",
    transform: "translate(-6.401 -11.778)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4470",
    "data-name": "Caminho 4470",
    d: "M19.957,48.3a.552.552,0,0,0-.866.684c.063.081,1.623,2.019,5.5,2.019s5.44-1.938,5.5-2.019a.551.551,0,0,0-.864-.684c-.054.066-1.335,1.6-4.639,1.6s-4.58-1.528-4.637-1.6",
    transform: "translate(-5.005 -12.687)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4471",
    "data-name": "Caminho 4471",
    d: "M19.15,27.623H14.556a.551.551,0,0,0,0,1.1H19.15a.551.551,0,0,0,0-1.1",
    transform: "translate(-3.694 -7.287)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4472",
    "data-name": "Caminho 4472",
    d: "M32.026,28.726H36.62a.551.551,0,1,0,0-1.1H32.026a.551.551,0,0,0,0,1.1",
    transform: "translate(-8.303 -7.287)",
    fill: "#4b4b4b"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdultsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adults_icon.b8f03675.svg";
export { ForwardRef as ReactComponent };